'use client';

import CabinPhotoNote from '@/components/property/CabinPhotoNote';
import { useState } from 'react';
import PhotoLightbox from '@/components/ui/PhotoLightbox';
import SmartImage from '@/components/ui/SmartImage';

export default function GalleryLightbox({
  images,
  slug,
  propertyName,
  photoAltTemplate = '{name} - Photo {n}',
}: {
  images: string[];
  slug: string;
  propertyName: string;
  photoAltTemplate?: string;
}) {
  const [galleryIdx, setGalleryIdx] = useState<number | null>(null);

  if (images.length <= 1) return null;

  const photoAlt = (n: number) =>
    photoAltTemplate.replaceAll('{name}', propertyName).replaceAll('{n}', String(n));

  return (
    <>
      {/* Photo Gallery Grid */}
      <section className="py-6 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
            {images.slice(1).map((img, idx) => (
              <button
                type="button"
                key={idx}
                className="relative aspect-[3/2] rounded-lg overflow-hidden cursor-pointer group"
                onClick={() => setGalleryIdx(idx + 1)}
              >
                <><SmartImage
                  src={img}
                  alt={photoAlt(idx + 2)}
                  sizes="(max-width: 640px) 50vw, (max-width: 1024px) 25vw, 20vw"
                  width={400}
                  height={267}
                  fill
                  className="object-cover transition-transform duration-300 group-hover:scale-105"
                  category="cabin"
                /><CabinPhotoNote slug={slug} src={img} compact /></>
              </button>
            ))}
          </div>
          {slug === "mestari" && images.some(src => src.startsWith("/images/cabins/baby-cabins/")) && <div><CabinPhotoNote slug={slug} src={images.find(src => src.startsWith("/images/cabins/baby-cabins/"))} caption /></div>}
        </div>
      </section>

      {galleryIdx !== null && (
        <PhotoLightbox index={galleryIdx} count={images.length} onClose={() => setGalleryIdx(null)} onPrevious={() => setGalleryIdx((galleryIdx - 1 + images.length) % images.length)} onNext={() => setGalleryIdx((galleryIdx + 1) % images.length)} caption={<><p>{photoAlt(galleryIdx + 1)}</p><CabinPhotoNote slug={slug} src={images[galleryIdx]} caption light /></>}>
          <SmartImage src={images[galleryIdx]} alt={photoAlt(galleryIdx + 1)} width={1200} height={800} fill className="object-contain" category="cabin" sizes="100vw" />
          <CabinPhotoNote slug={slug} src={images[galleryIdx]} compact />
        </PhotoLightbox>
      )}
    </>
  );
}
